import { render, staticRenderFns } from "./information.vue?vue&type=template&id=c9117880&"
import script from "./information.vue?vue&type=script&lang=js&"
export * from "./information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9117880')) {
      api.createRecord('c9117880', component.options)
    } else {
      api.reload('c9117880', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=c9117880&", function () {
      api.rerender('c9117880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/components/information.vue"
export default component.exports